<template>
  <div>
    <div class="web-box top-page">
      <a-row>
        <a-col :xs="24" :sm="12" class="top-left">
          <p>哔哩哔哩</p>
          <p>国内知名的弹幕视频分享网站</p>
          <div class="color-button" @click="goCallUs">
            联系我们
            <span class="button-icon">&#xe63a;</span>
          </div>
        </a-col>
        <a-col :xs="24" :sm="12">
          <img class="jixiangwu" src="http://www.vedamobi.com/assets/website/images/bilibili/ganbei.png" />
        </a-col>
      </a-row>
    </div>
    <p class="home-title product-title">产品介绍</p>
    <div class="web-box product-wrap">
      <div class="card card1">
        <h4>二次元垂直媒体</h4>
        <p>
          1.5亿活跃哟用户
          <br />7000+粉丝文化圈
          <br />每日新增100+TAG
          <br />每月新增100+万条UCG视频
          <br />人均访问时长95分钟
          <br />...
        </p>
        <img src="http://www.vedamobi.com/assets/website/images/bilibili/22.png" />
      </div>
      <div class="card card2">
        <h4>特殊定向维度</h4>
        <p>
          UP主粉丝关系定向
          <br />频道定向
          <br />视频关键词定向
          <br />APP兴趣定向
          <br />商业兴趣定向
          <br />...
        </p>
        <img src="http://www.vedamobi.com/assets/website/images/bilibili/33.png" />
      </div>
      <div class="card card3">
        <h4>高质量弹幕网站</h4>
        <p>
          最多日本独播番剧
          <br />最大国产动画观众群
          <br />最积极的版权聚集积累
          <br />最人文纪录片出产地
          <br />最大的年轻人潮流文化娱乐社区
          <br />...
        </p>
        <img src="http://www.vedamobi.com/assets/website/images/bilibili/44.png" />
      </div>
    </div>
    <swiper class="mobile-swiper" :options="swiperOption" ref="mySwiper">
      <!-- slides -->
      <swiper-slide>
        <div class="card card1">
          <h4>二次元垂直媒体</h4>
          <p>
            1.5亿活跃哟用户
            <br />7000+粉丝文化圈
            <br />每日新增100+TAG
            <br />每月新增100+万条UCG视频
            <br />人均访问时长95分钟
            <br />...
          </p>
          <img src="http://www.vedamobi.com/assets/website/images/bilibili/22.png" />
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="card card2">
          <h4>特殊定向维度</h4>
          <p>
            UP主粉丝关系定向
            <br />频道定向
            <br />视频关键词定向
            <br />APP兴趣定向
            <br />商业兴趣定向
            <br />...
          </p>
          <img src="http://www.vedamobi.com/assets/website/images/bilibili/33.png" />
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="card card3">
          <h4>高质量弹幕网站</h4>
          <p>
            最多日本独播番剧
            <br />最大国产动画观众群
            <br />最积极的版权聚集积累
            <br />最人文纪录片出产地
            <br />最大的年轻人潮流文化娱乐社区
            <br />...
          </p>
          <img src="http://www.vedamobi.com/assets/website/images/bilibili/44.png" />
        </div>
      </swiper-slide>
      <!-- Optional controls -->
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>

    <p class="home-title product-title">媒体详情</p>
    <div class="media-wrap">
      <p class="explain">
        &emsp;&emsp;哔哩哔哩（bilibili）是中国互联网上最精良、最及时的动画视频内容网站。哔哩哔哩上的视频来自用户的创作或搬运，不同于其他视频网站存在大量重复、低质量的视频内容，哔哩哔哩的搬运工是一群热爱动画的核心用户，他们能保证动画的内容质量和画面质量，能提供最及时、最清晰的动画视频内容。一部新番在日本播放完约1小时后，该视频的高清版就会被搬运到哔哩哔哩上。所以，哔哩哔哩聚集了大量的动画爱好者，形成了自己的口碑和影响力。
        <br />&emsp;&emsp;哔哩哔哩移动客户端专注于ACG相关内容的在线视频分享，目前有10个分区：番剧、动画、游戏、娱乐、生活、电影、电视剧、音乐、科技、鬼畜、舞蹈、广告。除了搬运分享外，也有很多同人创作的作品和原创视频在哔哩哔哩首发。
      </p>
      <div class="media-content web-show">
        <a-row>
          <a-col :xs="12" :sm="6">
            <p class="icon">&#xe63b;</p>
            <p>
              85%+
              <br />16~30岁用户占比
            </p>
          </a-col>
          <a-col :xs="12" :sm="6">
            <p class="icon">&#xe6b3;</p>
            <p>
              100万+
              <br />活跃UP主
            </p>
          </a-col>
          <a-col :xs="12" :sm="6">
            <p class="icon">&#xe69e;</p>
            <p>
              1500万
              <br />UGC视频
            </p>
          </a-col>
          <a-col :xs="12" :sm="6">
            <p class="icon">&#xe6fe;</p>
            <p>
              16个
              <br />人均观看视频/日
            </p>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>
<script>
import ScrollReveal from "scrollreveal";
export default {
  data() {
    return {
      scrollReveal: ScrollReveal(),
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    this.scrollReveal.reveal(`.jixiangwu`, {
      duration: 600,
      delay: 0,
      origin: "right",
      reset: true,
      mobile: false,
      distance: "500px",
      opacity: 0.001,
      easing: "linear"
    });
    for (const index of [1, 2, 3]) {
      this.scrollReveal.reveal(`.card${index}`, {
        // 动画的时长
        duration: 500,
        // 延迟时间
        delay: 200 * (index - 1),
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "bottom",
        // 回滚的时候是否再次触发动画
        reset: true,
        // 在移动端是否使用动画
        mobile: false,
        // 滚动的距离，单位可以用%，rem等
        distance: "200px",
        // 其他可用的动画效果
        opacity: 0.001,
        easing: "linear"
      });
    }
  },
  methods: {
    goCallUs() {
      const btn = document.getElementById("callusForm");
      const scrollHeight = btn.offsetTop;
      window.scrollTo(0, scrollHeight);
    }
  }
};
</script>
<style lang="scss" scoped>
.top-page {
  overflow: hidden;
  padding-top: 180px;
  .top-left {
    text-align: center;
    p:nth-child(1) {
      margin-top: 160px;
      font-size: 44px;
    }
    p:nth-child(2) {
      font-size: 22px;
    }
    .color-button {
      margin-top: 80px;
    }
  }
  .jixiangwu {
    width: 600px;
    height: 600px;
  }
  .button-icon {
    font-family: iconFont;
    float: right;
    padding-right: 10px;
  }
}
.media-wrap {
  max-width: 1300px;
  width: 100%;
  padding: 0 20px;
  margin: 0 auto;
  .explain {
    font-size: 20px;
    line-height: 50px;
  }
  .media-content {
    div {
      flex: 1;
      text-align: center;
      margin-top: 40px;
      .icon {
        font-family: "iconFont";
        font-size: 100px;
        margin: 0;
      }
    }
  }
}
.product-wrap {
  display: flex;
}
.mobile-swiper {
  display: none;
}
.card {
  flex: 1;
  margin: 0 25px;
  border-radius: 3px;
  box-shadow: 0 0 5px #9aa9ff;
  text-align: center;
  background-color: #fff;
  padding-top: 50px;
  h4 {
    font-size: 20px;
    font-weight: 600;
  }
  p {
    font-size: 18px;
    line-height: 50px;
  }
  img {
    width: 10rem;
    height: 10rem;
  }
  &:hover {
    box-shadow: 0 0 10px #7085ff;
  }
}
.product-title {
  text-align: center;
  margin-top: 200px;
}
@media (max-width: 750px) {
  .product-title {
    text-align: center;
    margin-top: 40px;
  }
  .top-page {
    overflow: hidden;
    padding-top: 80px;
    min-height: 100vh;
    .top-left {
      text-align: center;
      padding: 0 20px;
      p:nth-child(1) {
        margin-top: 60px;
        font-size: 24px;
      }
      p:nth-child(2) {
        font-size: 18px;
      }
      .color-button {
        margin-top: 30px;
      }
    }
    .jixiangwu {
      width: 100%;
      height: auto;
    }
  }
  .media-wrap {
    .explain {
      font-size: 16px;
      line-height: 30px;
    }
  }
  .product-wrap {
    display: none;
  }
  .mobile-swiper {
    display: block;
    .card {
      width: 100%;
      margin: 0;
      box-shadow: none;
    }
  }
}
</style>